/**
 * @author maxshurko@gmail.com
 * © 2026 Max Shurko. All Rights Reserved
 * This code is proprietary and may not be used, copied, or distributed without permission.
 * Use of this software is subject to the terms of a commercial license agreement.
 * No part of this software may be used without a valid license.
 */

import { MainPage } from './pages/main/MainPage';

import { LotsPage } from './pages/lot/LotsPage';

import { PublicationsPage } from './pages/publication/PublicationsPage';
import { PublicationViewPage } from './pages/publication/PublicationViewPage';
import { PublicationsAuthorPage } from './pages/publication/PublicationsAuthorPage';
import { PublicationCreatePage } from './pages/publication/PublicationCreatePage';

import { ProfilePage } from './pages/profile/ProfilePage';
import { ProfileForumTopicsPage } from './pages/profile/ProfileForumTopicsPage';
import { ProfileActiveLotsPage } from './pages/profile/ProfileActiveLotsPage';
import { ProfileFeedbacksPage } from './pages/profile/ProfileFeedbacksPage';
import { ProfilePublicationsPage } from './pages/profile/ProfilePublicationsPage';
import { ProfileSearchResultPage } from './pages/profile/ProfileSearchResultPage';

import { From1Page } from './pages/lot/From1Page';

import { ForumPage } from './pages/forum/ForumPage';
import { ForumTopicCreatePage } from './pages/forum/ForumTopicCreatePage';

const page = document.body.dataset.page;
switch (page) {

    case 'main':
        new MainPage();
        break;

    case 'lots':
        new LotsPage();
        break;

    case 'publications':
        new PublicationsPage();
        break;

    case 'publication':
        new PublicationViewPage();
        break;

    case 'publications-author':
        new PublicationsAuthorPage();
        break;

    case 'create-publication':
        new PublicationCreatePage();
        break;

    case 'profile':
        new ProfilePage();
        break;

    case 'profile-forum-topics':
        new ProfileForumTopicsPage();
        break;

    case 'profile-active-lots':
        new ProfileActiveLotsPage();
        break;

    case 'profile-feedbacks':
        new ProfileFeedbacksPage();
        break;

    case 'profile-publications':
        new ProfilePublicationsPage();
        break;

    case 'profile-search-result':
        new ProfileSearchResultPage();
        break;

    case 'from1':
        new From1Page();
        break;

    case 'topic':
        new ForumPage();
        break;

    case 'create-topic':
        new ForumTopicCreatePage();
        break;

    default:
        break;
}
